import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountJulaProUsers';

const AccountJulaProUsersSuspense = dynamic(
	() => import('./AccountJulaProUsers'),
	{ loading: () => <BlockLoadingSpinner /> },
);

export default function DynamicAccountJulaProUsers(props: Props) {
	return <AccountJulaProUsersSuspense {...props} />;
}
DynamicAccountJulaProUsers.displayName = 'DynamicAccountJulaProUsers';
